import { Priority } from './priority.model';

export class TaskDTO {
    id?: number;
    title: string;
    description?: string | null = null;
    submittedByUserId?: number | null = null;
    showreport?: number | null = null;
    showId?: number | null = null;
    priority?: Priority = Priority.Medium;
    imageIds?: number[] = [];
    removedImageIds?: number[] = [];

}
